import { render, staticRenderFns } from "./MenuMember.vue?vue&type=template&id=3acd5873&scoped=true&"
var script = {}
import style0 from "./MenuMember.vue?vue&type=style&index=0&id=3acd5873&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3acd5873",
  null
  
)

export default component.exports